import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useBuildData } from "../hooks/use-build-data"
import { useStaticQuery, graphql } from "gatsby"

function SEO({ description, lang, meta, title, nodeImageUrl }) {
  const buildInfos = useBuildData().site_settings
  let hostName = ""
  if (typeof window !== `undefined`) {
    hostName = window.location.origin
  }
  const faviconFid = buildInfos.favicon?.fid
  const data = useStaticQuery(graphql`
    query {
      images: allFileFile {
        edges {
          node {
            drupal_internal__fid
            localFile {
              SlugifiedPublicUrl
            }
          }
        }
      }
    }
  `)
  const image = data.images.edges
    .filter(({ node }) => node.drupal_internal__fid === faviconFid)
    .shift()

  let ogImageContent = ""
  if (nodeImageUrl === undefined) {
    ogImageContent = hostName + image?.node?.localFile?.SlugifiedPublicUrl
  } else {
    ogImageContent = hostName + nodeImageUrl
  }

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      link={[
        {
          rel: "icon",
          href: image?.node?.localFile?.SlugifiedPublicUrl,
        },
      ]}
      title={title}
      titleTemplate={`%s | ${buildInfos.website_name}`}
      meta={[
        {
          name: `description`,
          content: description,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: description,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `og:image`,
          content: ogImageContent,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: description,
        },
      ].concat(meta)}
    />
  )
}

//-----------------------Prop-Types---------------------------//

SEO.defaultProps = {
  lang: `fr`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  nodeImageUrl: PropTypes.string,
}

//-----------------------Prop-types---------------------------//

export default SEO
